export default __webpack_public_path__ + "static/media/EN_Co-fundedbytheEU_RGB_NEG.1ce4b969.png";